import { FunctionComponent, PropsWithChildren, useCallback } from "react";

import Grid from "@mui/material/Grid";
import { OrganizationRoutes } from "@simplyk/common";
import { useRouter } from "next/router";

import { getFromSessionStorage, setInSessionStorage } from "../../helpers/sessionStorage";
import { useTranslate } from "../../hooks/useTranslate";

import { DashboardMobilePopup } from "./DashboardMobilePopup";
import { ViewFormLink } from "./ViewFormLink";

import { DashboardButton } from "@/dashboard-design-system/Button/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

const isConnectBankPopupClosedSessionStorageKey = "isConnectBankPopupClosed";

type DashboardMobileConnectBankPopupProps = {
  isDisplayed: boolean;
};

export const DashboardMobileConnectBankPopup: FunctionComponent<
  PropsWithChildren<DashboardMobileConnectBankPopupProps>
> = ({ children, isDisplayed }) => {
  const { t } = useTranslate();
  const { pathname } = useRouter();

  const onConnectBankPopupClose = useCallback(() => {
    setInSessionStorage?.(isConnectBankPopupClosedSessionStorageKey, "true");
  }, []);
  const isConnectBankPopupClosed = Boolean(getFromSessionStorage?.(isConnectBankPopupClosedSessionStorageKey));
  const allowedPages = [
    OrganizationRoutes.Campaigns.toString(),
    OrganizationRoutes.Payments.toString(),
    OrganizationRoutes.Contacts.toString(),
    OrganizationRoutes.Emails.toString(),
  ];
  const isAllowedPage = allowedPages.includes(pathname);

  return (
    <DashboardMobilePopup
      onClose={onConnectBankPopupClose}
      shouldDisplay={isAllowedPage && !isConnectBankPopupClosed && isDisplayed}
      popupContent={
        <>
          <Grid item xs={12}>
            <DashboardTypography variant="h6" vibe="neutral100">
              {t("dashboard", "mobilePopup.connectYourBank.title")}
            </DashboardTypography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <DashboardButton
                  vibe="alternate"
                  variant="filled"
                  size="large"
                  href={OrganizationRoutes.Bank}
                  onClick={onConnectBankPopupClose}
                >
                  {t("dashboard", "mobilePopup.connectYourBank.bank.button")}
                </DashboardButton>
              </Grid>
              <Grid item xs={12}>
                <DashboardTypography variant="h6" vibe="neutral100">
                  {t("common", "or")}
                </DashboardTypography>
              </Grid>
              <Grid item xs={12}>
                <ViewFormLink />
              </Grid>
            </Grid>
          </Grid>
        </>
      }
    >
      {children}
    </DashboardMobilePopup>
  );
};
